import { render, staticRenderFns } from "./SettingsTemplate.vue?vue&type=template&id=7309c2dc"
import script from "./SettingsTemplate.vue?vue&type=script&lang=js"
export * from "./SettingsTemplate.vue?vue&type=script&lang=js"
import style0 from "./SettingsTemplate.vue?vue&type=style&index=0&id=7309c2dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports